export default "__VITE_ASSET__C6j2kJ7Z__"